import * as React from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Tooltip from '@mui/material/Tooltip';
import { SaveAlt } from '@mui/icons-material';
import { ButtonOptions as StyledButton } from './styles';

export default function ButtonOptions({ label, options, onSelect }) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleMenuItemClick = (event, index, option) => {
    if (onSelect) {
      onSelect(option, index);
    }
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <React.Fragment>
      <StyledButton
        ref={anchorRef}
        aria-controls={open ? 'split-button-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="menu"
        onClick={handleToggle}
        startIcon={<SaveAlt />}
      >
        {label || "Opciones"}
      </StyledButton>
      <Popper
        sx={{
          zIndex: 999,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {Array.isArray(options) && options.map((option, index) => {
                    const menuItem = (
                      <MenuItem
                        key={index}
                        disabled={option.disabled}
                        onClick={(event) => {
                          if (option.onClick) {
                            option.onClick(event);
                            setOpen(false);
                          } else {
                            handleMenuItemClick(event, index, option);
                          }
                        }}
                        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                      >
                        {option.icon && option.icon}
                        {option.label || option}
                      </MenuItem>
                    );

                    if (option.tooltip) {
                      return (
                        <Tooltip key={index} title={option.tooltip}>
                          {option.disabled ? <div>{menuItem}</div> : menuItem}
                        </Tooltip>
                      );
                    }
                    return menuItem;
                  })}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
}
